module.exports = __webpack_public_path__ + "static/media/smileys.71705a23.svg";